import { render, staticRenderFns } from "./Assignorgroup.vue?vue&type=template&id=f3f8fe8c&"
import script from "./Assignorgroup.vue?vue&type=script&lang=js&"
export * from "./Assignorgroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports